<mat-card id="component-container" style="padding-bottom: 1px; margin-top: 5%; margin-bottom: 3%;">
  <mat-card>
    <h2 id="title">PPI Network</h2>
  </mat-card>

  <mat-card class='input_card'>
    <div class='search-container'>
      <!-- Reorganized layout with grid structure -->
      <div class="search-grid">
        <!-- First row: Protein Type and ID -->
        <div class="grid-row">
          <div class="grid-cell">
            <label class="input-label">
              PROTEIN TYPE
              <mat-icon class="info-icon" matTooltip="Select the type of protein identifier you're using">info</mat-icon>
            </label>
            <mat-form-field appearance="outline" class="full-width">
              <mat-select [(ngModel)]="proteinType">
                <mat-option value="UniprotID">UniProt ID</mat-option>
                <mat-option value="IntAct">IntAct ID</mat-option>
                <mat-option value="LocusID">Locus ID</mat-option>
                <mat-option value="STRING">STRING ID</mat-option>
              </mat-select>
              
            </mat-form-field>
          </div>
          
          <div class="grid-cell">
            <label class="input-label">
              PROTEIN ID
              <mat-icon class="info-icon" matTooltip="Enter the protein identifier you want to search for">info</mat-icon>
            </label>
            <mat-form-field appearance="outline" class="full-width">
              <input matInput id="protein_id" [placeholder]="getPlaceholder()" [(ngModel)]="targetProtein" required>
              
              <mat-error *ngIf="!targetProtein">Protein ID is required</mat-error>
            </mat-form-field>
          </div>
        </div>
        
        <!-- Second row: Search Level and Species -->
        <div class="grid-row">
          <div class="grid-cell">
            <label class="input-label">
              SEARCH LEVEL
              <mat-icon class="info-icon" matTooltip="Determines how many levels of interactions to include in the network">info</mat-icon>
            </label>
            <mat-form-field appearance="outline" class="full-width">
              <mat-select [(ngModel)]="searchLevel">
                <mat-option [value]="1">1 (Direct interactions only)</mat-option>
                <mat-option [value]="2">2 (Secondary interactions)</mat-option>
                <mat-option [value]="3">3 (Tertiary interactions)</mat-option>
              </mat-select>
              
            </mat-form-field>
          </div>
          
          <div class="grid-cell">
            <label class="input-label">
              SPECIES
              <mat-icon class="info-icon" matTooltip="Select the species to filter interactions">info</mat-icon>
            </label>
            <mat-form-field appearance="outline" class="full-width">
              <mat-select [(ngModel)]="species">
                <mat-option *ngFor="let id of taxonomyIds" [value]="id">
                  {{ id }} - {{ getSpeciesName(id) }}
                </mat-option>
              </mat-select>
              
            </mat-form-field>
          </div>
        </div>
        
        <!-- Search button row -->
        <div class="grid-row search-button-row">
          <button mat-flat-button color="primary" class="search-button" (click)="fn_search()" [disabled]="!targetProtein">
            <mat-icon>search</mat-icon> SEARCH
          </button>
        </div>
      </div>
    </div>
  </mat-card>

  <mat-card class="card" style="margin-top: 0px; margin-bottom: 10px;">
    <pre style="overflow-x:hidden;">
  Note:
  User may submit a query protein ID to search the PPI information.
  The red node indicates the input protein.
  The blue node indicates the protein that has PPI with the input protein.
    </pre>
    
    <!-- Loading indicator with more details -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <div style="margin-left: 20px;">
        <h3>Loading protein interaction data...</h3>
        <p>Searching for interactions with protein: <strong>{{targetProtein}}</strong></p>
        <p>Search level: <strong>{{searchLevel}}</strong> | Species: <strong>{{species}}</strong></p>
        <p><em>This may take a moment for proteins with many interactions</em></p>
      </div>
    </div>
    
    <!-- Error message with more helpful guidance -->
    <div *ngIf="hasError && !isLoading" class="error-message">
      <mat-icon color="warn">error</mat-icon>
      <div>
        <h3>Error</h3>
        <p>{{ errorMessage }}</p>
        <p>Suggestions:</p>
        <ul>
          <li>Check that your protein ID is correct</li>
          <li>Try a different protein type (UniProt, IntAct, etc.)</li>
          <li>Try adjusting the search level or species</li>
          <li>Common proteins: Q9ZWT2 (Arabidopsis), P04637 (Human p53)</li>
        </ul>
      </div>
    </div>
    
    <!-- Cytoscape network visualization -->
    <app-cytoscape-ppinetwork *ngIf="!isLoading && !hasError && ELEMENT_DATA" [cytoData]="ELEMENT_DATA"></app-cytoscape-ppinetwork>
  </mat-card>
</mat-card>
